import { IonGrid } from "@ionic/react";
import React from "react";
import StopDetails from "./StopDetails";

const LoadTileMiddle:React.FC<any> = (props:any) => {

  return (
       <IonGrid class="stop-details-grid">
        {props.loadStop
          ? props.loadStop.map((stop: any, index: any) => (
            <StopDetails
            {...props}
              key={index}
              stopDetails={stop}
              appointment={(stop && props.calculateTime(stop)) || ""}
              length={props.loadStop.length}
              index={index}
              showExpandView={props.showExpandView}
              isCarrierLoad={props.isCarrierLoad}
              isAddressSelectable={false}
              isLastElement ={(index+1) === props.loadStop.length}
            />
          ))
          : null}
      </IonGrid>
    );
}

export default LoadTileMiddle;
